export default "__VITE_ASSET__BLhrBSGw__"